import type { RouteRecordRaw } from 'vue-router';

const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const CommercePage = () => import('../pages/Commerce/index.vue');

export const commerceRoutes: Array<RouteRecordRaw> = [
  {
    path: '/commerce',
    name: 'commerce',
    redirect: {
      name: 'commerce-index',
    },
    component: EmptyLayout,
    children: [
      {
        path: '',
        name: 'commerce-index',
        component: CommercePage,
      },
    ],
  },
];
